import LoginError from './LoginError';
class UnusualAccess extends LoginError {
    constructor(options) {
        super('The Investor is accessing from an unusual location.', options);
    }
}
export default UnusualAccess;
